import { render, staticRenderFns } from "./list-info.vue?vue&type=template&id=086f7cf5"
import script from "./list-info.vue?vue&type=script&lang=ts"
export * from "./list-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports